import wx from 'weixin-js-sdk'
import {getSignature} from '../api/api'



let appId 
if(location.host === 'h5.mogugu.com'){
    appId = 'wx0bf70d6510078c7e'
}else{
    appId = 'wxbee0d24bc1eb601c';
}

const shareImpl = (option) => {
let lsUrl
if(location.host === 'h5.mogugu.com'){
    // lsUrl = 'https://h5.mogugu.com/'
    lsUrl = window.location.href
}else{
    // lsUrl = 'https://rdt.h5.mogugu.com/'
    lsUrl = window.location.href
}
let params = {
    url:lsUrl
    // url:'https://rdt.h5.mogugu.com/'
};
    getSignature(params).then(
        (res)=>{
            console.log('res',res)
            console.log('option',option)
            wx.config({
                debug: false,
                appId: appId,
                timestamp: res.timestamp,
                nonceStr: res.noncestr,
                signature: res.signature,
                jsApiList: [
                    'onMenuShareAppMessage',
                    'onMenuShareTimeline',
                ]
            });
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: [
                        'getLocation',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage'
                    ],
                    success: function (res) {
                        // alert(JSON.stringify(res));
                    }
                });

                wx.onMenuShareAppMessage({
                    title: option.shareTitle,
                    desc: option.shareDesc,
                    link: option.shareUrl,
                    imgUrl: option.shareImg,
                    success:function(){
                        console.log('fenxiangFriendSuccess')
                    }
                });
                wx.onMenuShareTimeline({
                    title: option.shareTitle,
                    // desc: option.shareDesc,
                    link: option.shareUrl,
                    imgUrl: option.shareImg,
                    success:function(){
                        console.log('fenxiangpengyouquanSuccess')
                    }
                });
            })
        },
        (err)=>{console.log('err',err)}
        )
}


export default shareImpl


// WEBPACK FOOTER //
// ./src/utils/wxApi.js